import { SxProps, TextField, TextFieldProps, Theme } from '@mui/material'
import { Controller } from 'react-hook-form'
// import InputMask from "react-input-mask";
import { useMask } from '@react-input/mask'

type FormInputProps = {
    name: string
    control: any
    label: string
    setValue?: any
    sx?: SxProps<Theme>
    type?: React.InputHTMLAttributes<unknown>['type']
    disabled?: boolean
    rows?: string | number
    readonly?: boolean
    mask?: string
} & TextFieldProps
const FormInputContact = ({
    mask,
    name,
    control,
    label,
    sx,
    type,
    disabled,
    rows,
    placeholder,
    variant,
}: FormInputProps) => {
    const inputRef = useMask({
        mask: mask || '____ ___ ___',
        replacement: { _: /\d/ },
    })

    return (
        <Controller
            name={name}
            control={control}
            render={(renderProps) => (
                <TextField
                    inputRef={inputRef}
                    value={renderProps.field.value || ''}
                    onChange={renderProps.field.onChange}
                    type={type}
                    error={!!renderProps.fieldState.error}
                    helperText={renderProps.fieldState?.error?.message ?? null}
                    fullWidth
                    label={label}
                    sx={sx}
                    variant={variant || 'outlined'}
                    // disabled={disabled}
                    autoComplete="tel"
                    slotProps={{
                        htmlInput: {
                            autoComplete: 'tel',
                        },
                        input: {
                            readOnly: Boolean(disabled),
                        },
                    }}
                    disabled={disabled}
                    rows={rows}
                    multiline={Boolean(rows)}
                    aria-readonly
                    placeholder={placeholder}
                />
                // </InputMask >
            )}
        />
    )
}

export default FormInputContact
